import { Button, Result } from 'antd';
import styled from 'styled-components';

const CustomResult = styled(Result)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto`;

const ErrorFallback = ({ error, resetErrorBoundary }: { error: Error, resetErrorBoundary: () => void }) => {
  return (
    <CustomResult
      status="error"
      title={error.message}
      extra={
        <Button type="primary" key="console" onClick={resetErrorBoundary}>
          Tentar Novamente
        </Button>
      }
    />
  );
};

export default ErrorFallback;
